import NsContent from 'components/common/ns-content/NsContent';
import NsDownload from '@britishgasenergy/react-nucleus/dist/nuc-components/NsDownload';

import { NsCheckboxInput } from 'components/common/ns-checkbox-input/NsCheckboxInput';
import { NsInputterValidations } from 'components/common/ns-inputter/NsInputterValidations';
import { actionUrl } from 'config/static-content';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import NsInputterEvent from 'components/common/ns-inputter/NsInputterEvent';

export const testId = 'termsAndConditionsTestId';

type TermsAndConditionsProps = {
  handleChange?: (event: NsInputterEvent) => void;
  tariffTermsPDF?: string;
  isTOU: boolean;
};

export const TermsAndConditions = ({
  handleChange,
  tariffTermsPDF,
  isTOU
}: TermsAndConditionsProps) => {
  const isTouCheckBoxCopy = isTOU
    ? `I've read and accept the British Gas Terms & Conditions, 
  Tariff Terms & Conditions, Privacy Policy and agree to half-hourly meter 
  readings`
    : `I've read and accept the British Gas Terms & Conditions and The
  Tariff Terms & Conditions`;

  return (
    <>
      <div>
        <h3>Important documents</h3>
        <NsContent>
          <p>
            <NsSecondaryCta
              href={actionUrl.bgTermsAndConditions}
              icon="external-link"
            >
              British Gas Terms & Conditions
            </NsSecondaryCta>
          </p>
          <p>
            <NsDownload href={tariffTermsPDF}>
              This Tariff Terms & Conditions
            </NsDownload>
          </p>
          <p>
            <NsSecondaryCta href={actionUrl.privacy} icon="external-link">
              Privacy policy
            </NsSecondaryCta>
          </p>
        </NsContent>
      </div>
      <NsCheckboxInput
        name="terms"
        testId={testId}
        onChange={handleChange}
        options={[{ label: isTouCheckBoxCopy, value: 'true' }]}
        validation={[NsInputterValidations.isRequired]}
      />
    </>
  );
};
